import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConfigService} from '@docma-mm-core/config/config.service';
import {BasedataService} from '@docma-mm-core/shared/basedata.service';
import {Observable} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {Integration} from '@docma-mm-core/integration/integration';
import {IntegrationFile} from '@docma-mm-core/integration/integration-file';

@Injectable()
export class IntegrationApiService extends BasedataService {

  private integrationsUrl = '/configuration/integrations';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }
  private getIntegrationUrl() {
    return super.getFullUrl(this.integrationsUrl);
  }

  getIntegrations(top: number = 1000, skip: number = 0): Observable<Integration[]> {
    const endpoint = this.getIntegrationUrl();
    let httpParams = new HttpParams();
    if (top) { httpParams = httpParams.set('$top', top.toString()); }
    if (skip) { httpParams = httpParams.set('$skip', skip.toString()); }
    return this.http
      .get(endpoint, { headers: this.getHeaders(), params: httpParams })
      .pipe(
        map((dt: any) => {
          return dt && dt.Data ?  dt.Data : [] ;
        }),
        catchError( e => this.handleError(e))
      );

  }

  getIntegrationFile(integrationId: number): Observable<{file: IntegrationFile, blob: Blob}> {
    const endpoint = super.getFullUrl(`/integrations/${integrationId}/image`);

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Accept', 'application/json');

    return this.http
      .get<any>(endpoint, { headers, responseType: 'blob' as 'json' })
      .pipe(catchError(e  => this.handleError(e)))
      .pipe(switchMap(async x => {
        return {
          file: {
            Id: x.Id,
            ImageFileName: x.ImageFileName,
            mimeType: x.type,
            buffer: await x.arrayBuffer()
          } as IntegrationFile,
          blob: x};
      }));
  }


}
